const BASE_URL = process.env.REACT_APP_API_KEY;

const getHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };
};

const handleResponse = (r) => {
  if (r.status === 401) {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("permissions");
    // Remember where the user was (path + query string) so login.jsx can
    // send them back here instead of always landing on "/" — the 401
    // triggers a full reload (App.js re-runs its /authen check and renders
    // <Login/> in place of the router), so this has to survive a reload;
    // sessionStorage does, localStorage would too but sessionStorage is the
    // right lifetime for a one-shot "return to" value. Skip capturing when
    // already on /login so a stale value from before this session doesn't
    // linger past its own redirect.
    if (window.location.pathname !== "/login") {
      sessionStorage.setItem(
        "postLoginRedirect",
        window.location.pathname + window.location.search,
      );
    }
    window.location.reload();
    return Promise.reject(new Error("Token expired"));
  }
  if (r.status === 403) {
    window.location.href = "/forbidden";
  }
  return r.json();
};

const ApiConfig = {
  get: (endpoint) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: getHeaders(),
    }).then(handleResponse),

  post: (endpoint, body) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify(body),
    }).then(handleResponse),

  put: (endpoint, body) =>
    fetch(`${BASE_URL}${endpoint}`, {
      method: "PUT",
      headers: getHeaders(),
      body: JSON.stringify(body),
    }).then(handleResponse),
};

export default ApiConfig;
